import { request } from 'Lib/axios'
import { useQuery } from '@tanstack/react-query'
import { ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { CurrenciesTypes } from 'Types/Currencies'

interface AccountMetadata {
  clickceaseInterval: string
  clickceasePrice: number
  currency: Lowercase<CurrenciesTypes>
  essentialsDiscountPercentage: number
  essentialsDiscountPrice: number
  essentialsProductPrice: number
  planAccepted: boolean
}

const getAccountMetadata = async (accountId: number) =>
  await request<{ data: AccountMetadata }>({
    url: `accounts-migration/${accountId}/metadata`,
    method: 'GET',
  })

type QueryFnType = typeof getAccountMetadata

export const useGetAccountMetadata = (isMigrationAccount?: boolean) => {
  const { accountId } = useUserStore()
  isMigrationAccount = typeof isMigrationAccount === 'boolean' ? isMigrationAccount : true

  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryFn: () => getAccountMetadata(accountId),
    queryKey: ['getAccountMetadata', accountId],
    enabled: !!accountId && !!isMigrationAccount,
  })

  const data = query.data && query.data instanceof Error ? undefined : query.data?.data

  return { ...query, data }
}
